import React from "react"
import { Link } from "gatsby"
import {
  buttonContainer,
  buttonStyle,
  buttonStyleDark,
  link,
} from "./getintouch.module.scss"
import { themeState } from "../state"
import { useRecoilValue } from "recoil"

const GetInTouch = () => {
  const theme = useRecoilValue(themeState)
  return (
    <section>
      <div className={buttonContainer}>
        <Link to="/contact" className={link}>
          <button className={theme ? buttonStyleDark : buttonStyle}>
            Get In Touch
          </button>
        </Link>
      </div>
    </section>
  )
}

export default GetInTouch
